import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-tablet',
    templateUrl: './tablet.component.svg',
    styleUrls: ['./tablet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabletComponent {}
